export default __webpack_public_path__ + "static/media/chocolate-mobile@2x.4a6ee648.jpg";